import { useState } from "react";

const faqs = [
  {
    q: "What type of contractor is Taurus Contracting?",
    a: "Taurus Contracting is a commercial general contractor based in Toronto, Ontario. They specialize in general contracting, design/build project delivery, commercial leasehold improvements, pre-construction services, and project management for commercial and institutional clients across Ontario.",
  },
  {
    q: "What is design/build contracting and how does it work?",
    a: "Design/build contracting integrates both the design and construction phases under a single contract and team. This approach streamlines communication, reduces risk, and typically results in faster project delivery and better cost control compared to traditional design-bid-build methods. Taurus manages the entire process from concept through completion.",
  },
  {
    q: "What are commercial leasehold improvements?",
    a: "Commercial leasehold improvements are renovations or modifications made to a rented commercial space to suit a tenant's specific business needs. This includes office fit-outs, retail environments, partition walls, flooring, ceilings, and mechanical upgrades. Taurus Contracting delivers these projects on schedule and on budget.",
  },
  {
    q: "What does pre-construction services include?",
    a: "Pre-construction services include project budgeting, scheduling, constructability reviews, value engineering, and procurement planning — all completed before construction begins. Taurus uses this phase to identify risks early, optimize costs, and ensure the build phase runs smoothly and efficiently.",
  },
  {
    q: "What areas in Ontario does Taurus Contracting serve?",
    a: "Taurus Contracting serves commercial and institutional clients across the Greater Toronto Area and broader Ontario, including Toronto, Scarborough, Mississauga, Brampton, Markham, Vaughan, Richmond Hill, Pickering, Ajax, Whitby, Oshawa, Burlington, Oakville, and Hamilton.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-28 px-6 lg:px-12" style={{ background: "#f7f6f4" }}>
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
          {/* Left label */}
          <div className="lg:col-span-1">
            <span
              className="text-stone-400 text-xs uppercase tracking-[0.28em] font-medium block mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              FAQ
            </span>
            <h2
              className="text-stone-900 font-semibold leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2rem, 3vw, 2.8rem)" }}
            >
              Common
              <br />
              <span className="font-light italic">Questions</span>
            </h2>
            <p
              className="text-stone-500 text-sm leading-relaxed mt-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Can&apos;t find your answer? Call us directly at{" "}
              <a href="tel:4167241172" className="text-stone-800 font-medium hover:underline">
                (416) 724-1172
              </a>
            </p>
          </div>

          {/* Right: accordion */}
          <div className="lg:col-span-2 space-y-2">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className={`rounded-sm border transition-all duration-200 overflow-hidden ${
                  open === idx ? "border-stone-300 bg-white" : "border-stone-200 bg-white/60"
                }`}
              >
                <button
                  onClick={() => setOpen(open === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                >
                  <span
                    className="text-stone-800 font-medium text-sm pr-6 leading-relaxed"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {faq.q}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${open === idx ? "bg-stone-900" : "bg-stone-100"}`}>
                    <i className={`${open === idx ? "ri-subtract-line text-white" : "ri-add-line text-stone-500"} text-xs`}></i>
                  </div>
                </button>
                {open === idx && (
                  <div className="px-6 pb-6">
                    <p
                      className="text-stone-500 text-sm leading-relaxed"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
